import React from 'react';
import { Tooltip } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { BadgeStatus } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import messages from './messages';

type Props = {
  intl: Object,
};

const PortalBadge = ({ intl }: Props) => (
  <Tooltip
    title={intl.formatMessage(messages.portalAccountWarning)}
    placement="top"
  >
    <BadgeStatus size="small" status="inProgress">
      {intl.formatMessage(messages.portalBadge)}
    </BadgeStatus>
  </Tooltip>
);

export default PortalBadge;
